import(/* webpackMode: "eager" */ "/app/app/(locale)/cricket-hindi-news/error.tsx");
